import React, { useState, useEffect } from 'react';
import { Form, Modal, Row, Col, Button } from 'react-bootstrap';
import { Checkbox } from 'pretty-checkbox-react';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faColumns,
  faBolt,
  faDollarSign,
} from '@fortawesome/pro-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons';

import ApiServiceServerless from '../../../xhr_libs';
import EnergyTracerTable from '../../tables';
import PopoverTrigger from '../../PopoverTrigger';
import SmallerLoader from '../../SmallerLoader';
import { getPlugMeterNames } from '../../UtilityImportSettings/helpers/plug';

// trctl = tarriffRateComponentsTypeList
const costColumns = [
  { id: 1, dataField: 'chargeAmount', text: 'Cost Value' },
  { id: 2, dataField: 'chargeUnitsUsed', text: 'Usage Amount' },
  { id: 3, dataField: 'chargeNameAsPrinted', text: 'Cost Name' },
  { id: 4, dataField: 'chargeGroupHeading', text: 'Cost Group Type' },
  { id: 5, dataField: 'measurementType', text: 'Cost Usage Type' },
  { id: 6, dataField: 'contributionStatus', text: 'Contribution Status' },
  {
    id: 7,
    dataField: 'tariff',
    text: 'Tariff Provider Name',
    formatter: (cell) =>
      Object.keys(cell).includes('provider') &&
        Object.keys(cell.provider).includes('name')
        ? cell['provider']['name']
        : '',
  },
  { id: 8, dataField: 'trctl', text: 'Tariff Rate Component' },
];

const usageColumns = [
  { id: 1, dataField: 'measuredUsage', text: 'Measured Usage' },
  { id: 2, dataField: 'citedUsage', text: 'Cited Usage' },
  { id: 3, dataField: 'usageNameAsPrinted', text: 'Usage Name' },
  { id: 4, dataField: 'measurementType', text: 'Usage Type' },
  {
    id: 5,
    dataField: 'meterConstantMultiplier',
    text: 'Meter Constant Multiplier',
  },
  { id: 6, dataField: 'contributionStatus', text: 'Contribution Status' },
  { id: 7, dataField: 'trctl', text: 'Tariff Rate Component' },
];

const styles = {
  buttonStyle: {
    fontSize: '20px',
    color: 'var(--et_tab_grey)',
  },
  buttonContainerStyle: {
    cursor: 'pointer',
    pointerEvents: 'auto',
    display: 'inline-block',
    marginLeft: '0.25em',
  },
};

export default function ViewPlugLineItemsModal(props) {
  const {
    show,
    onHide,
    activeTemplateId,
    usageNames,
    costNames,
    organizationId,
    statements,
    statementIdx,
    setStatementIdx,
    accIdx,
    setAccIdx,
    meterIdx,
    setMeterIdx,
    results,
    setResults,
  } = props;

  const [costs, setCosts] = useState([]);
  const [usages, setUsages] = useState([]);

  const [localResults, setLocalResults] = useState([]);

  const [costColumnIds, setCostColumnIds] = useState([1, 3]);
  const [usageColumnIds, setUsageColumnIds] = useState([1, 3, 4]);

  const [localCostColumns, setLocalCostColumns] = useState([]);
  const [localUsageColumns, setLocalUsageColumns] = useState([]);

  const [showUsages, setShowsUsages] = useState(true);
  const [showCosts, setShowsCosts] = useState(true);

  const [loadedResults, setLoadedResults] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [costResultColumns, setCostResultsColumns] = useState([])
  const [usageResultColumns, setUsageResultsColumns] = useState([])

  const [selectAccountSelects, setSelectAccountSelects] = useState([])
  const [selectMeterSelects, setSelectMeterSelects] = useState([])


  useEffect(() => {
    let select_options = [{ 'value': '', 'label': '-' }]
    if (statements.length > 0 &&
      statements[statementIdx].accountData.length > 0) {
      select_options = []
      statements[statementIdx].accountData.forEach((acc, idx) => {
        select_options.push({
          'value': idx, 'label': `${idx + 1}. ${acc['provider']['classification'] === 'PUBLISHER'
            ? acc['accountNumber']
            : `${acc['accountNumber']} - Secondary`
            }`
        })
      })
    }
    setSelectAccountSelects(select_options)
  }, [statements, statementIdx])

  useEffect(() => {

    let select_options = [{ 'value': '', 'label': '-' }]
    if (statements.length > 0 &&
      statements[statementIdx].accountData.length > 0 &&
      statements[statementIdx].accountData[accIdx].meterData.length) {
      select_options = []
      statements[statementIdx].accountData[accIdx].meterData.forEach((mtr, idx) => {
        const meter_number = getPlugMeterNames(mtr, statements[statementIdx].accountData[accIdx])
        select_options.push({
          'value': idx, 'label': `${idx + 1}. ${meter_number}`
        })
      })
    }
    setSelectMeterSelects(select_options)
  }, [statements, accIdx, statementIdx])

  useEffect(() => {
    if (!usageNames || usageNames.length === 0) {
      setUsageResultsColumns([{ id: 1, dataField: 'usage0', text: 'Usage 1 Value' }])
    }
    else {
      let usages = []
      usageNames.forEach((usage, idx) => {
        usages.push({ 'id': idx + 1, dataField: `usage${idx}`, text: usage })
      })
      setUsageResultsColumns(usages)
    }
  }, [usageNames])


  useEffect(() => {
    if (!costNames || costNames.length === 0) {
      setCostResultsColumns([{ id: 1, dataField: 'cost0', text: 'Cost 1 Value' }])
    }
    else {
      let costs = []
      costNames.forEach((cost, idx) => {
        costs.push({ 'id': idx + 1, dataField: `cost${idx}`, text: cost })
      })
      setCostResultsColumns(costs)
    }
  }, [costNames])


  useEffect(() => {
    setLocalCostColumns(
      costColumns.filter((col) => costColumnIds.includes(col.id))
    );
  }, [costColumnIds]);

  useEffect(() => {
    setLocalUsageColumns(
      usageColumns.filter((col) => usageColumnIds.includes(col.id))
    );
  }, [usageColumnIds]);

  useEffect(() => {
    if (
      statements.length > 0 &&
      statements.length >= statementIdx &&
      statements[statementIdx].accountData.length >= accIdx &&
      statements[statementIdx].accountData[accIdx].meterData.length >= meterIdx
    ) {
      let local_usages = processUsages(statements[statementIdx].accountData[accIdx].meterData[meterIdx][
        'usages'
      ])
      let local_costs = processCosts(statements[statementIdx].accountData[accIdx].meterData[meterIdx][
        'charges'
      ])
      setCosts(local_costs);
      setUsages(local_usages);
    } else {
      setCosts([]);
      setUsages([]);
    }
  }, [statements, statementIdx, accIdx, meterIdx]);

  useEffect(() => {
    if (
      results.length > 0 &&
      results.length >= statementIdx &&
      results[statementIdx].accountData.length >= accIdx &&
      results[statementIdx].accountData[accIdx].meterData.length >= meterIdx
    ) {
      setLocalResults([
        results[statementIdx].accountData[accIdx].meterData[meterIdx]['result'],
      ]);
    } else {
      setLocalResults([]);
    }
  }, [results, statementIdx, accIdx, meterIdx]);

  // for custom fields
  const processUsages = (usages) => {
    return usages.map((usage) => {
      let local_usage = usage;
      let trctl = [] //tarriffRateComponentsTypeList
      local_usage['tariffRateComponents'].forEach((tar) => { trctl.push(tar.tariffRateComponentType) })
      local_usage['trctl'] = trctl.join(',')
      return local_usage
    })
  }

  // for custom fields
  const processCosts = (costs) => {
    return costs.map((cost) => {
      let local_cost = cost;
      let trctl = []
      local_cost['tariffRateComponents'].forEach((tar) => { trctl.push(tar.tariffRateComponentType) })
      local_cost['trctl'] = trctl.join(',')
      return local_cost
    })
  }

  const handleTestTemplate = () => {
    setIsLoading(true);
    setLoadedResults(0);
    testTemplate([], 0);
  };

  const testTemplate = (local_results, idx) => {
    setIsLoading(true);
    let statementId = null;
    if (statements.length > 0 && statements.length >= idx) {
      statementId = statements[idx]['id'];
    }

    ApiServiceServerless.get(
      `/custom_templates/test/${activeTemplateId}/${statementId}`,
      { authorization_id: organizationId }
    )
      .then((res) => {
        local_results = [...local_results, res.data];
        if (idx + 1 >= statements.length) {
          setResults(local_results);
          setIsLoading(false);
        } else {
          setLoadedResults((prev) => prev + 1);
          testTemplate(local_results, idx + 1);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size='xl'>
        <Modal.Header closeButton style={{ height: '50px' }}>
          {'Statements'}
        </Modal.Header>

        <Modal.Body>
          <Form as={Row}>
            {statements.length > 0 && (
              <Form.Group as={Col}>
                <Form.Label>Statement End Date</Form.Label>
                <Form.Control
                  as='select'
                  required
                  value={statementIdx}
                  onChange={(e) => {
                    setMeterIdx(0);
                    setAccIdx(0);
                    setStatementIdx(e.target.value);
                  }}
                >
                  {statements.map((opt, idx) => (
                    <option key={`statment-opt-${idx}`} value={idx}>
                      {`${idx + 1}. ${opt['periodEndDate']}`}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            )}
            <Form.Group as={Col}>
              <Form.Label>Account</Form.Label>
              <Select
                key={[selectAccountSelects, statementIdx]}
                defaultValue={selectAccountSelects[0]}
                onChange={(option) => { setMeterIdx(0); setAccIdx(option.value) }}
                options={selectAccountSelects}
                classNamePrefix='et-react-select'
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Meter</Form.Label>
              <Select
                key={[selectMeterSelects, accIdx]}
                defaultValue={selectMeterSelects[0]}
                onChange={(option) => { setMeterIdx(option.value) }}
                options={selectMeterSelects}
                classNamePrefix='et-react-select'
              />
            </Form.Group>


          </Form>
          <Row style={{ paddingLeft: '1em', marginBottom: '1em' }}>
            <FontAwesomeIcon
              style={{
                fontSize: '21px',
                lineHeight: 'inherit',
                color: 'var(--et_tab_grey)',
                cursor: 'pointer',
                opacity: showUsages ? '1' : '0.5',
                marginRight: '0.5em',
              }}
              icon={faBolt}
              title={'Toggle Usages'}
              onClick={() => {
                setShowsUsages((prev) => !prev);
              }}
            />
            <FontAwesomeIcon
              style={{
                fontSize: '21px',
                lineHeight: 'inherit',
                color: 'var(--et_tab_grey)',
                cursor: 'pointer',
                opacity: showCosts ? '1' : '0.5',
              }}
              icon={faDollarSign}
              title={'Toggle Costs'}
              onClick={() => {
                setShowsCosts((prev) => !prev);
              }}
            />
          </Row>
          <Button onClick={() => handleTestTemplate()} disabled={isLoading}>
            Test template
          </Button>
          {results.length > 0 && (
            <FontAwesomeIcon
              style={{
                fontSize: '20px',
                lineHeight: 'inherit',
                color: 'red',
                cursor: 'pointer',
                position: 'relative',
                top: '2px',
                left: '8px',
              }}
              icon={faTimesCircle}
              title={'Clear results'}
              onClick={() => {
                setResults([]);
              }}
            />
          )}
          {isLoading && (
            <>
              {` ${loadedResults}/${statements.length}  `}
              <SmallerLoader />
            </>
          )}
          <br></br>
          <br></br>

          {showUsages && (
            <>
              <h5 style={{ display: 'inline-block' }}>Usages</h5>
              <LocalPopover
                label='usage'
                columns={usageColumns}
                activeColumnIds={usageColumnIds}
                setActiveColumnIds={setUsageColumnIds}
              />
              {localUsageColumns.length > 0 && (
                <EnergyTracerTable data={usages} columns={localUsageColumns} />
              )}
              {localResults.length > 0 && (
                <>
                  <h5 style={{ display: 'inline-block' }}>Usage Results</h5>
                  <EnergyTracerTable
                    data={localResults}
                    columns={usageResultColumns}
                  />
                </>
              )}
            </>
          )}
          {showCosts && (
            <>
              <h5 style={{ display: 'inline-block' }}>Costs</h5>
              <LocalPopover
                label='cost'
                columns={costColumns}
                activeColumnIds={costColumnIds}
                setActiveColumnIds={setCostColumnIds}
              />
              {localCostColumns.length > 0 && (
                <EnergyTracerTable data={costs} columns={localCostColumns} />
              )}
              {localResults.length > 0 && (
                <>
                  <h5 style={{ display: 'inline-block' }}>Cost Results</h5>
                  <EnergyTracerTable
                    data={localResults}
                    columns={costResultColumns}
                  />
                </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

function ColumnSelect(props) {
  const { columns, activeColumnIds, setActiveColumnIds } = props;

  const updateLocalSelected = (id) => {
    setActiveColumnIds((prev) => {
      if (!prev.includes(id)) return [...prev, id];
      return prev.filter((el) => el !== id);
    });
  };

  return (
    <>
      {columns.map((col, idx) => (
        <Row key={idx} style={{ padding: '0.25em 0em 0.25em 1em' }}>
          <Checkbox
            style={{
              fontSize: '1.25em',
            }}
            color={'primary-o'}
            onChange={() => {
              updateLocalSelected(col.id);
            }}
            checked={activeColumnIds.includes(col.id)}
            key={col.id}
          ></Checkbox>
          <div style={{ position: 'relative', top: '-7px', left: '-8px' }}>
            {col.text}
          </div>
        </Row>
      ))}
    </>
  );
}

function LocalPopover(props) {
  const { label, columns, activeColumnIds, setActiveColumnIds } = props;
  return (
    <div id={`${label}-popover-button`} style={styles.buttonContainerStyle}>
      <PopoverTrigger
        rootClose={true}
        popoverTitle={`${label.charAt(0).toUpperCase() + label.substring(1).toLowerCase()
          } Columns`}
        popoverContent={
          <ColumnSelect
            columns={columns}
            activeColumnIds={activeColumnIds}
            setActiveColumnIds={setActiveColumnIds}
          />
        }
        trigger='click'
        placement='bottom'
      >
        <FontAwesomeIcon
          style={styles.buttonStyle}
          icon={faColumns}
          id={'report-date-popover'}
        />
      </PopoverTrigger>
    </div>
  );
}
